import React from 'react';
const NotFound = () => <div className="p-8">404 - Not Found</div>;
export default NotFound;
